/* eslint-disable */
import { useState, useMemo } from "react";
import { ALL_CLUBS_FLAT } from "./FootballData";

// Real semi-pro club names by tier for player generation
const REAL_CLUBS_T5 = ALL_CLUBS_FLAT.filter(c=>c.tierNum===5).map(c=>c.name);
const REAL_CLUBS_T6 = ALL_CLUBS_FLAT.filter(c=>c.tierNum===6).map(c=>c.name);
const REAL_CLUBS_T7 = ALL_CLUBS_FLAT.filter(c=>c.tierNum===7).map(c=>c.name);

/* ═══════════════════════════════════════════════
   FOOTY ANALYST — PLAYER DATABASE
   60+ players · Full FM profiles · Smart analysis
═══════════════════════════════════════════════ */

const DB_CSS = `
.db-wrap { padding: 0; font-family: 'DM Sans', sans-serif; }

/* ── HEADER BAR ── */
.db-header {
  background: var(--teal2);
  padding: 1.5rem 1.8rem;
  border-bottom: 3px solid var(--mustard);
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem;
}
.db-header-left h2 {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.8rem; letter-spacing: 3px; color: var(--white); line-height: 1;
}
.db-header-left p {
  font-size: 0.72rem; color: rgba(255,255,255,0.55);
  font-weight: 400; margin-top: 0.2rem; font-style: italic;
}
.db-stats-row { display: flex; gap: 1.5rem; }
.db-stat { text-align: center; }
.db-stat-n {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.6rem; letter-spacing: 2px; color: var(--mustard); line-height: 1;
}
.db-stat-l {
  font-size: 0.55rem; font-weight: 700; letter-spacing: 2px;
  text-transform: uppercase; color: rgba(255,255,255,0.45); margin-top: 0.1rem;
}

/* ── CONTROLS ── */
.db-controls {
  background: var(--white);
  border-bottom: 1.5px solid var(--rule);
  padding: 1rem 1.8rem;
  display: flex; gap: 0.8rem; flex-wrap: wrap; align-items: center;
}
.db-search {
  flex: 1; min-width: 200px;
  background: var(--cream); border: 1.5px solid var(--rule);
  border-bottom: 2.5px solid var(--teal);
  padding: 0.6rem 0.9rem; color: var(--ink);
  font-family: 'DM Sans', sans-serif; font-size: 0.85rem;
  font-weight: 500; outline: none;
}
.db-search:focus { border-bottom-color: var(--darkred); }
.db-select {
  background: var(--cream); border: 1.5px solid var(--rule);
  padding: 0.6rem 0.85rem; color: var(--ink);
  font-family: 'DM Sans', sans-serif; font-size: 0.75rem;
  font-weight: 600; outline: none; cursor: pointer;
  border-bottom: 2.5px solid var(--teal);
}
.db-view-btns { display: flex; border: 1.5px solid var(--rule); }
.db-view-btn {
  padding: 0.55rem 0.85rem; font-family: 'DM Sans', sans-serif;
  font-size: 0.72rem; font-weight: 800; cursor: pointer;
  border: none; background: transparent; color: var(--muted);
  letter-spacing: 1px; transition: all 0.2s;
  border-right: 1px solid var(--rule);
}
.db-view-btn:last-child { border-right: none; }
.db-view-btn.on { background: var(--teal); color: var(--white); }

/* ── POSITION FILTERS ── */
.db-pos-filters {
  background: var(--cream2);
  border-bottom: 1.5px solid var(--rule);
  padding: 0.65rem 1.8rem;
  display: flex; gap: 0.4rem; flex-wrap: wrap; align-items: center;
}
.db-pos-label {
  font-size: 0.6rem; font-weight: 800; letter-spacing: 2px;
  text-transform: uppercase; color: var(--muted); margin-right: 0.4rem;
}
.pos-btn {
  padding: 0.24rem 0.7rem; font-family: 'DM Sans', sans-serif;
  font-size: 0.64rem; font-weight: 800; letter-spacing: 1.5px;
  text-transform: uppercase; cursor: pointer;
  border: 1.5px solid var(--rule); color: var(--muted);
  background: var(--white); transition: all 0.2s;
}
.pos-btn:hover { border-color: var(--teal); color: var(--teal); }
.pos-btn.on { background: var(--teal); color: var(--white); border-color: var(--teal); }
.pos-btn.gk.on  { background: #f59e0b; border-color: #f59e0b; }
.pos-btn.def.on { background: var(--darkred); border-color: var(--darkred); }
.pos-btn.mid.on { background: var(--teal); border-color: var(--teal); }
.pos-btn.att.on { background: #16a34a; border-color: #16a34a; }

/* ── ATTRIBUTE SORT BAR ── */
.db-sort-bar {
  background: var(--cream);
  border-bottom: 1.5px solid var(--rule);
  padding: 0.5rem 1.8rem;
  display: flex; gap: 0.35rem; align-items: center; flex-wrap: wrap;
}
.sort-label { font-size: 0.6rem; font-weight: 800; letter-spacing: 2px; text-transform: uppercase; color: var(--muted); margin-right: 0.3rem; }
.sort-btn {
  padding: 0.2rem 0.65rem; font-family: 'DM Sans', sans-serif;
  font-size: 0.62rem; font-weight: 700; cursor: pointer;
  border: 1.5px solid var(--rule); color: var(--muted);
  background: transparent; transition: all 0.2s; letter-spacing: 1px;
}
.sort-btn:hover { border-color: var(--mustard); color: var(--mustard2); }
.sort-btn.on { background: var(--mustard); color: var(--ink); border-color: var(--mustard); }

/* ── RESULTS INFO ── */
.db-results-bar {
  padding: 0.55rem 1.8rem;
  display: flex; align-items: center; justify-content: space-between;
  background: var(--white); border-bottom: 1px solid var(--rule2);
}
.db-results-count {
  font-size: 0.7rem; font-weight: 700; color: var(--muted); letter-spacing: 1px;
}
.db-results-count span { color: var(--teal); font-weight: 800; }

/* ── GRID VIEW ── */
.db-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 1rem; padding: 1.2rem 1.8rem;
}

/* ── PLAYER CARD ── */
.pc {
  background: var(--white); border: 1.5px solid var(--rule);
  transition: all 0.22s; cursor: pointer; position: relative;
  animation: fadeInUp 0.3s ease both;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
.pc:hover { border-color: var(--ink); box-shadow: 4px 4px 0 var(--ink); transform: translate(-2px,-2px); }
.pc.watched { border-top: 4px solid var(--teal); }
.pc.high-potential::after {
  content: '⭐ HIGH POTENTIAL';
  position: absolute; top: 0.6rem; right: 0.6rem;
  font-size: 0.5rem; font-weight: 800; letter-spacing: 1.5px;
  background: var(--mustard); color: var(--ink);
  padding: 0.12rem 0.4rem;
}

/* Card header */
.pc-head {
  padding: 0.85rem 0.95rem;
  border-bottom: 1.5px solid var(--rule);
  background: var(--cream2);
  display: flex; align-items: flex-start; justify-content: space-between;
}
.pc-left { flex: 1; }
.pc-name { font-family: 'DM Sans', sans-serif; font-size: 0.95rem; font-weight: 800; color: var(--ink); }
.pc-club { font-family: 'DM Sans', sans-serif; font-size: 0.62rem; color: var(--muted); margin-top: 0.08rem; font-weight: 400; }
.pc-tags { display: flex; gap: 0.3rem; margin-top: 0.28rem; flex-wrap: wrap; }
.pc-pos {
  font-family: 'DM Sans', sans-serif; font-size: 0.54rem; font-weight: 800;
  padding: 0.12rem 0.4rem; letter-spacing: 1.5px; text-transform: uppercase;
}
.pc-pos.gk  { background: #f59e0b; color: var(--ink); }
.pc-pos.def { background: var(--darkred); color: var(--white); }
.pc-pos.mid { background: var(--teal); color: var(--white); }
.pc-pos.att { background: #16a34a; color: var(--white); }
.pc-age {
  font-size: 0.54rem; font-weight: 700; padding: 0.12rem 0.4rem;
  border: 1px solid var(--rule); color: var(--muted); letter-spacing: 1px;
}
.pc-right { text-align: right; }
.pc-ovr {
  font-family: 'Bebas Neue', sans-serif; font-size: 2.2rem;
  letter-spacing: 2px; color: var(--darkred); line-height: 1;
}
.pc-ovr-lbl {
  font-family: 'DM Sans', sans-serif; font-size: 0.5rem; color: var(--muted);
  letter-spacing: 2px; text-transform: uppercase; font-weight: 600;
}
.pc-pot {
  font-family: 'DM Sans', sans-serif; font-size: 0.58rem; font-weight: 700;
  color: var(--teal); margin-top: 0.15rem; letter-spacing: 0.5px;
}

/* Attributes */
.pc-attrs { display: grid; grid-template-columns: repeat(3,1fr); gap: 2px; padding: 0.6rem 0.95rem; }
.pc-attr { background: var(--cream2); padding: 0.26rem 0.4rem; display: flex; justify-content: space-between; align-items: center; border: 1px solid var(--rule2); }
.pc-attr-l { font-family: 'DM Sans', sans-serif; font-size: 0.56rem; color: var(--muted); text-transform: uppercase; letter-spacing: 1px; font-weight: 700; }
.pc-attr-v { font-family: 'Bebas Neue', sans-serif; font-size: 0.92rem; letter-spacing: 1px; }
.av-hi { color: #16a34a; } .av-md { color: var(--mustard2); } .av-lo { color: var(--darkred); }

/* Card body */
.pc-body { padding: 0.65rem 0.95rem; }
.pc-info-row { display: flex; justify-content: space-between; margin-bottom: 0.28rem; }
.pc-info-l { font-size: 0.64rem; color: var(--muted); font-weight: 400; font-style: italic; }
.pc-info-v { font-size: 0.64rem; color: var(--ink); font-weight: 700; }
.pc-style { font-size: 0.65rem; color: var(--teal); font-style: italic; font-weight: 600; margin-top: 0.3rem; }

/* Radar mini */
.pc-radar { display: flex; gap: 3px; align-items: flex-end; height: 28px; margin: 0.5rem 0; }
.pc-radar-bar { flex: 1; background: var(--rule2); position: relative; border-radius: 1px; }
.pc-radar-fill { position: absolute; bottom: 0; left: 0; right: 0; border-radius: 1px; transition: height 0.3s; }

/* Actions */
.pc-actions { display: flex; gap: 0.38rem; padding: 0.68rem 0.95rem; border-top: 1px solid var(--rule2); }
.pc-btn {
  flex: 1; padding: 0.4rem; font-family: 'DM Sans', sans-serif;
  font-size: 0.62rem; font-weight: 800; letter-spacing: 1.5px;
  text-transform: uppercase; cursor: pointer; border: 1.5px solid var(--rule);
  color: var(--ink3); background: transparent; transition: all 0.2s;
}
.pc-btn:hover { background: var(--ink); color: var(--white); border-color: var(--ink); }
.pc-btn.watch-on { background: var(--teal); color: var(--white); border-color: var(--teal); }

/* ── LIST VIEW ── */
.db-list { padding: 0 1.8rem 1.2rem; }
.db-list-header {
  display: grid;
  grid-template-columns: 28px 1fr 80px 55px 55px 55px 55px 55px 55px 90px 100px;
  gap: 0.4rem; padding: 0.5rem 0.8rem;
  background: var(--cream2); border: 1.5px solid var(--rule);
  margin-top: 1rem;
}
.db-list-header span {
  font-family: 'DM Sans', sans-serif; font-size: 0.58rem; font-weight: 800;
  letter-spacing: 1.5px; text-transform: uppercase; color: var(--muted);
}
.db-list-row {
  display: grid;
  grid-template-columns: 28px 1fr 80px 55px 55px 55px 55px 55px 55px 90px 100px;
  gap: 0.4rem; padding: 0.52rem 0.8rem;
  border: 1px solid var(--rule2); border-top: none;
  background: var(--white); cursor: pointer; transition: all 0.18s;
  align-items: center;
}
.db-list-row:hover { background: var(--teal4); border-color: var(--teal); }
.db-list-n { font-family: 'Bebas Neue', sans-serif; font-size: 0.9rem; letter-spacing: 1px; color: var(--muted); text-align: center; }
.db-list-name { font-family: 'DM Sans', sans-serif; font-size: 0.82rem; font-weight: 700; color: var(--ink); }
.db-list-club { font-size: 0.62rem; color: var(--muted); font-weight: 400; }
.db-list-pos { display: flex; align-items: center; }
.db-list-attr { font-family: 'Bebas Neue', sans-serif; font-size: 0.95rem; letter-spacing: 1px; text-align: center; }
.db-list-ovr { font-family: 'Bebas Neue', sans-serif; font-size: 1.1rem; letter-spacing: 1px; color: var(--darkred); text-align: center; }
.db-list-val { font-family: 'DM Sans', sans-serif; font-size: 0.7rem; font-weight: 700; color: var(--ink); }
.db-list-actions { display: flex; gap: 0.25rem; }
.db-list-btn {
  flex: 1; padding: 0.22rem 0.3rem; font-family: 'DM Sans', sans-serif;
  font-size: 0.56rem; font-weight: 800; letter-spacing: 1px; text-transform: uppercase;
  cursor: pointer; border: 1px solid var(--rule); color: var(--muted);
  background: transparent; transition: all 0.2s;
}
.db-list-btn:hover { background: var(--teal); color: var(--white); border-color: var(--teal); }

/* ── PLAYER PROFILE MODAL ── */
.pp-modal {
  position: fixed; inset: 0; background: rgba(26,22,18,0.95);
  z-index: 800; overflow-y: auto; padding: 1.5rem;
}
.pp-inner { max-width: 860px; margin: 0 auto; }
.pp-back {
  background: var(--teal); color: var(--white); border: 2px solid var(--teal);
  padding: 0.48rem 1.1rem; font-family: 'DM Sans', sans-serif; font-size: 0.72rem;
  font-weight: 800; letter-spacing: 2px; text-transform: uppercase; cursor: pointer;
  margin-bottom: 1.2rem; transition: all 0.2s;
}
.pp-back:hover { background: var(--ink); border-color: var(--ink); }

/* Profile header */
.pp-header {
  background: var(--teal2); border: 1.5px solid var(--teal);
  padding: 1.5rem; margin-bottom: 1rem;
  display: flex; gap: 1.5rem; flex-wrap: wrap; align-items: flex-start;
}
.pp-avatar {
  width: 70px; height: 70px; background: var(--teal);
  border: 3px solid var(--mustard); display: flex; align-items: center;
  justify-content: center; font-family: 'Bebas Neue', sans-serif;
  font-size: 1.6rem; letter-spacing: 2px; color: var(--white); flex-shrink: 0;
}
.pp-info { flex: 1; }
.pp-name {
  font-family: 'Bebas Neue', sans-serif; font-size: 2.2rem;
  letter-spacing: 3px; color: var(--white); line-height: 1;
}
.pp-detail { font-size: 0.72rem; color: rgba(255,255,255,0.6); margin-top: 0.25rem; font-weight: 400; }
.pp-tags { display: flex; gap: 0.4rem; margin-top: 0.6rem; flex-wrap: wrap; }
.pp-tag {
  font-family: 'DM Sans', sans-serif; font-size: 0.58rem; font-weight: 800;
  padding: 0.14rem 0.48rem; letter-spacing: 1.5px; text-transform: uppercase;
  border: 1.5px solid rgba(255,255,255,0.3); color: rgba(255,255,255,0.8);
}
.pp-tag.highlight { background: var(--mustard); color: var(--ink); border-color: var(--mustard); }
.pp-ovr-block { text-align: right; }
.pp-ovr {
  font-family: 'Bebas Neue', sans-serif; font-size: 4.5rem;
  letter-spacing: 3px; color: var(--mustard); line-height: 1;
}
.pp-ovr-lbl { font-size: 0.55rem; color: rgba(255,255,255,0.45); letter-spacing: 2px; text-transform: uppercase; font-weight: 600; }
.pp-pot-block { margin-top: 0.4rem; }
.pp-pot-lbl { font-size: 0.55rem; color: rgba(255,255,255,0.45); letter-spacing: 2px; text-transform: uppercase; font-weight: 600; }
.pp-pot-bar-bg { width: 80px; height: 6px; background: rgba(255,255,255,0.15); margin: 0.25rem 0 0 auto; border-radius: 2px; }
.pp-pot-bar-fill { height: 100%; background: var(--mustard); border-radius: 2px; }

/* Profile grid */
.pp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem; }
.pp-panel { background: var(--white); border: 1.5px solid var(--rule); padding: 1.1rem; }
.pp-panel-title {
  font-family: 'Bebas Neue', sans-serif; font-size: 0.95rem; letter-spacing: 2.5px;
  color: var(--ink); margin-bottom: 0.9rem; padding-bottom: 0.6rem;
  border-bottom: 1.5px solid var(--rule); display: flex; align-items: center;
  justify-content: space-between;
}
.pp-panel-chip {
  font-family: 'DM Sans', sans-serif; font-size: 0.54rem; font-weight: 800;
  padding: 0.14rem 0.46rem; background: var(--teal); color: var(--white);
  letter-spacing: 2px; text-transform: uppercase;
}

/* Full attribute display */
.pp-attrs-full { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem; }
.pp-attr-row { display: flex; align-items: center; gap: 0.6rem; }
.pp-attr-label { font-size: 0.68rem; font-weight: 700; color: var(--muted); width: 80px; text-transform: uppercase; letter-spacing: 0.5px; flex-shrink: 0; }
.pp-attr-bar-bg { flex: 1; height: 6px; background: var(--cream2); border-radius: 2px; position: relative; }
.pp-attr-bar-fill { position: absolute; top: 0; left: 0; height: 100%; border-radius: 2px; }
.pp-attr-val { font-family: 'Bebas Neue', sans-serif; font-size: 1rem; letter-spacing: 1px; width: 28px; text-align: right; }

/* Strengths & weaknesses */
.sw-list { display: flex; flex-direction: column; gap: 0.45rem; }
.sw-item { display: flex; align-items: flex-start; gap: 0.6rem; font-size: 0.78rem; line-height: 1.5; }
.sw-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 0.28rem; }
.sw-dot.good { background: #16a34a; }
.sw-dot.bad { background: var(--darkred); }

/* Coaching recommendations */
.coach-recs { display: flex; flex-direction: column; gap: 0.6rem; }
.coach-rec {
  background: var(--teal4); border: 1px solid var(--rule);
  border-left: 4px solid var(--teal); padding: 0.7rem 0.9rem;
}
.coach-rec-title { font-size: 0.78rem; font-weight: 800; color: var(--ink); margin-bottom: 0.2rem; }
.coach-rec-desc { font-size: 0.72rem; color: var(--ink3); font-style: italic; font-weight: 300; line-height: 1.6; }

/* Pro style match */
.style-match {
  background: var(--white); border: 1.5px solid var(--rule); padding: 0.75rem 0.95rem;
  margin-bottom: 0.5rem; display: flex; align-items: center; gap: 0.8rem;
  cursor: pointer; transition: all 0.2s;
}
.style-match:hover { border-color: var(--teal); background: var(--teal4); }
.style-match-color { width: 8px; height: 40px; border-radius: 2px; flex-shrink: 0; }
.style-match-info { flex: 1; }
.style-match-club { font-size: 0.82rem; font-weight: 800; color: var(--ink); }
.style-match-reason { font-size: 0.68rem; color: var(--muted); font-style: italic; font-weight: 300; margin-top: 0.1rem; }
.style-match-pct { font-family: 'Bebas Neue', sans-serif; font-size: 1.4rem; letter-spacing: 1px; color: var(--teal); }

/* Scout report form */
.sr-form { display: flex; flex-direction: column; gap: 0.7rem; }
.sr-label { font-size: 0.62rem; font-weight: 800; letter-spacing: 2px; text-transform: uppercase; color: var(--muted); margin-bottom: 0.2rem; display: block; }
.sr-input { width: 100%; background: var(--cream2); border: 1.5px solid var(--rule); padding: 0.6rem 0.85rem; color: var(--ink); font-family: 'DM Sans', sans-serif; font-size: 0.85rem; font-weight: 500; outline: none; }
.sr-input:focus { border-color: var(--teal); }
.sr-ta { width: 100%; background: var(--cream2); border: 1.5px solid var(--rule); padding: 0.6rem 0.85rem; color: var(--ink); font-family: 'DM Sans', sans-serif; font-size: 0.82rem; outline: none; height: 80px; resize: vertical; font-style: italic; font-weight: 300; }
.sr-stars { display: flex; gap: 0.3rem; }
.sr-star { font-size: 1.3rem; cursor: pointer; opacity: 0.2; transition: opacity 0.2s; color: var(--mustard); }
.sr-star.on { opacity: 1; }
.sr-interest { display: flex; gap: 0.4rem; flex-wrap: wrap; }
.sr-int-btn {
  flex: 1; padding: 0.45rem; font-family: 'DM Sans', sans-serif;
  font-size: 0.64rem; font-weight: 800; letter-spacing: 1.5px; text-transform: uppercase;
  cursor: pointer; border: 1.5px solid var(--rule); color: var(--muted);
  background: transparent; transition: all 0.2s; white-space: nowrap;
}
.sr-int-btn.on.sign   { background: #16a34a; border-color: #16a34a; color: var(--white); }
.sr-int-btn.on.monitor{ background: var(--mustard); border-color: var(--mustard); color: var(--ink); }
.sr-int-btn.on.keep   { background: var(--teal); border-color: var(--teal); color: var(--white); }
.sr-int-btn.on.pass   { background: var(--darkred); border-color: var(--darkred); color: var(--white); }
.sr-submit {
  width: 100%; padding: 0.82rem; background: var(--teal); color: var(--white);
  border: 2px solid var(--teal); font-family: 'DM Sans', sans-serif; font-weight: 800;
  font-size: 0.76rem; letter-spacing: 2px; text-transform: uppercase; cursor: pointer; transition: all 0.2s;
}
.sr-submit:hover { background: var(--ink); border-color: var(--ink); }

/* Compare bar */
.compare-bar {
  position: fixed; bottom: 0; left: 240px; right: 0;
  background: var(--teal2); border-top: 3px solid var(--mustard);
  padding: 0.8rem 1.8rem; display: flex; align-items: center; gap: 1rem;
  z-index: 100; flex-wrap: wrap;
}
.compare-bar-title { font-family: 'Bebas Neue', sans-serif; font-size: 1rem; letter-spacing: 2px; color: var(--white); }
.compare-players { display: flex; gap: 0.5rem; flex: 1; flex-wrap: wrap; }
.compare-player-chip {
  background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2);
  padding: 0.3rem 0.8rem; display: flex; align-items: center; gap: 0.5rem;
  font-size: 0.72rem; font-weight: 700; color: var(--white);
}
.compare-remove { cursor: pointer; opacity: 0.6; font-size: 0.8rem; }
.compare-remove:hover { opacity: 1; }
.btn-compare {
  background: var(--mustard); color: var(--ink); border: none;
  padding: 0.55rem 1.4rem; font-family: 'DM Sans', sans-serif; font-weight: 800;
  font-size: 0.72rem; letter-spacing: 2px; text-transform: uppercase; cursor: pointer;
}
.btn-compare-clear {
  background: transparent; color: rgba(255,255,255,0.5); border: 1px solid rgba(255,255,255,0.2);
  padding: 0.55rem 1rem; font-family: 'DM Sans', sans-serif; font-weight: 700;
  font-size: 0.7rem; letter-spacing: 1.5px; text-transform: uppercase; cursor: pointer;
}

/* Compare modal */
.cmp-grid { display: grid; gap: 1rem; margin-top: 1rem; }
.cmp-attr-row { display: flex; align-items: center; gap: 0.5rem; padding: 0.4rem 0; border-bottom: 1px solid var(--rule2); }
.cmp-attr-l { font-size: 0.68rem; font-weight: 700; color: var(--muted); text-transform: uppercase; letter-spacing: 1px; width: 70px; flex-shrink: 0; }
.cmp-bar-wrap { flex: 1; display: flex; align-items: center; gap: 0.4rem; }
.cmp-bar-bg { flex: 1; height: 6px; background: var(--cream2); border-radius: 2px; position: relative; }
.cmp-bar-fill { position: absolute; top: 0; height: 100%; border-radius: 2px; }
.cmp-val { font-family: 'Bebas Neue', sans-serif; font-size: 0.95rem; letter-spacing: 1px; width: 24px; }

/* No results */
.db-empty { text-align: center; padding: 4rem 2rem; }
.db-empty-icon { font-size: 3rem; margin-bottom: 1rem; }
.db-empty-title { font-family: 'Bebas Neue', sans-serif; font-size: 1.6rem; letter-spacing: 2px; margin-bottom: 0.4rem; }
.db-empty-sub { font-size: 0.85rem; color: var(--muted); font-style: italic; font-weight: 300; }
`;

/* ═══════════════════════════════════════════════
   PLAYER DATA — 250 players across all positions
   Multiple ability tiers · Rich names · Real clubs
   Wonderkids · Veterans · Free agents · Loan players
═══════════════════════════════════════════════ */
/* ── SEEDED RANDOM — same players every session ── */
let _seed = 42;
const seededRand = () => {
  _seed = (_seed * 1664525 + 1013904223) & 0xffffffff;
  return ((_seed >>> 0) / 0xffffffff);
};
const resetSeed = () => { _seed = 42; };

const generatePlayers = () => {
  resetSeed();

  /* ── NAMES — 120 first, 120 last for variety ── */
  const firstNames = [
    // English/British
    "Marcus","Jordan","Theo","Daniel","Ryan","James","Alex","Sam","Tom","Harry","Jack","Ben","Oliver","George","Ethan","Noah","Mason","Liam","Finn","Caleb","Dylan","Aaron","Leon","Zak","Jude","Kian","Leo","Max","Noel","Owen","Dean","Karl","Glen","Adam","Scott","Craig","Darren","Gary","Wayne","Steven","Jamie","Robbie","Kevin","Paul","Mark","Lee","Neil","Andy","Dave","Chris",
    // European
    "Luca","Nico","Hugo","Mateo","Rafe","Cruz","Elias","Felix","Gael","Ivan","Seb","Rico","Malik","Yusuf","Dion","Luis","Carlos","Sergio","Andres","Xavi","Cesc","Juan","Pablo","Miguel","Diego","Roberto","Javier","Angel","Victor","Manuel","Toni","Florian","Julian","Niklas","Kai","Leroy","Ilkay","Thomas","Joshua","Bernd","Robin","Erik","Simon","Thiago","Lucas","Bruno","Ruben","Joao","Nuno","Ricardo","Rafa",
    // African/South American
    "Kofi","Omar","Kwame","Yaw","Seun","Tunde","Chidi","Emeka","Kelechi","Sadio","Moussa","Idrissa","Cheikh","Ousmane","Ismail","Edson","Vinicius","Raphael","Gabriel","Marquinhos","Fabinho","Fred","Rodri","Darwin","Facundo","Maximo","Enzo","Valentino","Alexis","Arturo","Claudio","Eduardo","Felipe","Gino","Hector","Ignacio","Jorge","Keylor","Lorenzo",
    // Asian/other
    "Takumi","Koji","Ryo","Yuki","Shinji","Keisuke","Hwang","Son","Heung","Cho","Park","Lee","Kim","Mehdi","Karim","Rachid","Hakim","Riyad","Sofiane","Nabil"
  ];

  const lastNames = [
    // English/British
    "Webb","Ellis","Bright","Ford","Scott","Hassan","Clarke","Hughes","Davies","Wilson","Taylor","Brown","Jones","Evans","Thomas","Roberts","Lewis","Walker","Hall","Allen","Young","King","Wright","Green","Baker","Hill","Wood","Morris","Bell","Shaw","Cook","Rogers","Morgan","Reed","Bailey","Cox","Ward","Brooks","Price","Gray","Armstrong","Stone","Lane","Hart","Mills","Burns","Flynn","Nash","Carr","Moss",
    // European
    "Romano","Nakamura","Fernandez","Garcia","Martinez","Lopez","Sanchez","Perez","Rodriguez","Gonzalez","Hernandez","Diaz","Torres","Ramirez","Flores","Morales","Jimenez","Reyes","Cruz","Vargas","Muller","Schmidt","Schneider","Fischer","Weber","Meyer","Wagner","Becker","Hoffman","Schulz","Koch","Richter","Klein","Wolf","Schroeder","Neuer","Kroos","Kimmich","Werner","Havertz",
    // African/South American
    "Mane","Koulibaly","Dembele","Diatta","Sarr","Kouyate","Ndoye","Camara","Bamba","Toure","Keita","Coulibaly","Traore","Sissoko","Pogba","Silva","Santos","Oliveira","Souza","Lima","Costa","Alves","Neves","Carvalho","Pereira","Moura","Firmino","Coutinho","Willian","David","Lodi","Militao","Danilo","Arthur","Casemiro",
    // Mixed/other
    "Benzema","Zidane","Kante","Mendy","Saliba","Coman","Thuram","Pavard","Varane","Lloris","Mbappe","Griezmann","Giroud","Dembele","Martial","Aouar","Fekir","Ndombele","Sissoko","Matuidi"
  ];

  /* ── CLUBS — real National League pyramid ── */
  const clubs = {
    tier1: REAL_CLUBS_T5,
    tier2: REAL_CLUBS_T6,
    tier3: REAL_CLUBS_T7,
    tier4: REAL_CLUBS_T7,
  };

  /* ── NATIONALITIES ── */
  const nats = [
    {flag:"🏴󠁧󠁢󠁥󠁮󠁧󠁿",country:"England",weight:18},
    {flag:"🏴󠁧󠁢󠁳󠁣󠁴󠁿",country:"Scotland",weight:5},
    {flag:"🏴󠁧󠁢󠁷󠁬󠁳󠁿",country:"Wales",weight:4},
    {flag:"🇮🇪",country:"Republic of Ireland",weight:4},
    {flag:"🇫🇷",country:"France",weight:8},
    {flag:"🇩🇪",country:"Germany",weight:7},
    {flag:"🇪🇸",country:"Spain",weight:7},
    {flag:"🇧🇷",country:"Brazil",weight:6},
    {flag:"🇵🇹",country:"Portugal",weight:5},
    {flag:"🇳🇱",country:"Netherlands",weight:5},
    {flag:"🇦🇷",country:"Argentina",weight:4},
    {flag:"🇸🇳",country:"Senegal",weight:3},
    {flag:"🇳🇬",country:"Nigeria",weight:3},
    {flag:"🇬🇭",country:"Ghana",weight:2},
    {flag:"🇨🇮",country:"Ivory Coast",weight:2},
    {flag:"🇨🇲",country:"Cameroon",weight:2},
    {flag:"🇲🇦",country:"Morocco",weight:2},
    {flag:"🇯🇵",country:"Japan",weight:2},
    {flag:"🇰🇷",country:"South Korea",weight:2},
    {flag:"🇮🇹",country:"Italy",weight:4},
    {flag:"🇧🇪",country:"Belgium",weight:3},
    {flag:"🇺🇸",country:"USA",weight:2},
    {flag:"🇺🇾",country:"Uruguay",weight:2},
    {flag:"🇨🇴",country:"Colombia",weight:2},
    {flag:"🇵🇱",country:"Poland",weight:2},
    {flag:"🇸🇪",country:"Sweden",weight:2},
    {flag:"🇩🇰",country:"Denmark",weight:2},
    {flag:"🇳🇴",country:"Norway",weight:1},
    {flag:"🇨🇭",country:"Switzerland",weight:1},
    {flag:"🇦🇹",country:"Austria",weight:1},
    {flag:"🇨🇿",country:"Czech Republic",weight:1},
    {flag:"🇺🇦",country:"Ukraine",weight:1},
    {flag:"🇿🇦",country:"South Africa",weight:1},
    {flag:"🇦🇺",country:"Australia",weight:1},
    {flag:"🇨🇦",country:"Canada",weight:1},
    {flag:"🇲🇽",country:"Mexico",weight:1},
  ];

  // Weighted nationality picker
  const totalNatWeight = nats.reduce((s,n)=>s+n.weight,0);
  const pickNat = () => {
    let r = seededRand()*totalNatWeight;
    for(const n of nats){ r-=n.weight; if(r<=0) return n.flag; }
    return nats[0].flag;
  };

  /* ── POSITIONS CONFIG ── */
  const positions = [
    { pos:"GK",  group:"gk",  count:20,
      styles:["Sweeper Keeper","Shot-stopper","Distribution Keeper","Commanding Keeper","Aggressive Keeper","Penalty Specialist","Rushing Keeper","Traditional Keeper","Modern Keeper","Half-Back Keeper"],
      attrs:{ pace:[42,68], shooting:[18,42], passing:[52,82], dribbling:[30,55], defending:[70,94], physical:[62,88] } },
    { pos:"CB",  group:"def", count:35,
      styles:["Ball-playing CB","Defensive CB","Aerial CB","Sweeper CB","Aggressive CB","Libero","No-Nonsense CB","Covering CB","Press-resistant CB","Modern CB"],
      attrs:{ pace:[52,80], shooting:[28,55], passing:[58,84], dribbling:[42,68], defending:[72,94], physical:[70,92] } },
    { pos:"RB",  group:"def", count:18,
      styles:["Attacking Full-back","Defensive Full-back","Inverted Full-back","Wing-back","Overlapping Full-back","Disciplined Full-back","Modern Full-back","Box-to-Box Full-back"],
      attrs:{ pace:[70,94], shooting:[42,70], passing:[62,85], dribbling:[62,85], defending:[62,86], physical:[65,86] } },
    { pos:"LB",  group:"def", count:18,
      styles:["Attacking Full-back","Defensive Full-back","Inverted Full-back","Wing-back","Overlapping Full-back","Disciplined Full-back","Modern Full-back","Marauding Full-back"],
      attrs:{ pace:[70,94], shooting:[42,70], passing:[62,85], dribbling:[62,85], defending:[62,86], physical:[65,86] } },
    { pos:"CDM", group:"mid", count:22,
      styles:["Holding Midfielder","Press-breaker","Defensive Anchor","Screener","Destroyer","Ball-winner","Regista","Deep-lying Playmaker","Modern CDM","Shield"],
      attrs:{ pace:[58,80], shooting:[48,72], passing:[66,88], dribbling:[60,82], defending:[70,90], physical:[70,90] } },
    { pos:"CM",  group:"mid", count:32,
      styles:["Box-to-Box","Creative CM","Press Trigger","Progressive Passer","Late Runner","Engine","Mezzala","Roaming Playmaker","Workhorse","Ball-carrying CM","Dynamic CM","Tempo Controller"],
      attrs:{ pace:[62,86], shooting:[58,82], passing:[70,92], dribbling:[66,88], defending:[55,80], physical:[62,84] } },
    { pos:"CAM", group:"mid", count:22,
      styles:["Creative Playmaker","Shadow Striker","Advanced Playmaker","No.10","Enganche","Trequartista","False 10","Link Player","Attacking Midfielder","Goal-scoring 10","Deep Playmaker"],
      attrs:{ pace:[65,88], shooting:[68,90], passing:[72,94], dribbling:[72,94], defending:[38,62], physical:[55,76] } },
    { pos:"LW",  group:"att", count:22,
      styles:["Pacey Winger","Inverted Winger","Creative Winger","Direct Winger","Wide Forward","Inside Forward","Traditional Winger","Goal-scoring Winger","Pressing Winger","Dribbling Specialist"],
      attrs:{ pace:[76,97], shooting:[62,88], passing:[62,85], dribbling:[76,96], defending:[35,60], physical:[58,80] } },
    { pos:"RW",  group:"att", count:22,
      styles:["Pacey Winger","Inverted Winger","Wide Forward","Creative Winger","Cutting Inside","Inside Forward","Traditional Winger","Goal-scoring Winger","Pressing Winger","Direct Winger"],
      attrs:{ pace:[76,97], shooting:[62,88], passing:[62,85], dribbling:[76,96], defending:[35,60], physical:[58,80] } },
    { pos:"ST",  group:"att", count:38,
      styles:["Clinical Finisher","Target Man","Pressing Striker","False 9","Poacher","Link Striker","Advanced Forward","Complete Forward","Penalty Box Striker","Hold-up Striker","Deep Striker","Goal Machine","Aerial Threat","Pace Merchant","Physical Striker"],
      attrs:{ pace:[68,95], shooting:[75,97], passing:[52,80], dribbling:[65,90], defending:[28,54], physical:[65,90] } },
  ];

  /* ── PERSONALITIES ── */
  const personalities = ["Determined","Professional","Model Citizen","Ambitious","Perfectionist","Driven","Leader","Light-hearted","Laid-back","Temperamental","Volatile","Flair","Resolute","Spirited","Jovial","Balanced","Realist","Unambitious","Slack","Media Friendly"];

  /* ── PRO REFERENCES ── */
  const proRefs = {
    GK:  ["Alisson Becker","Ederson","David de Gea","Marc-Andre ter Stegen","Jan Oblak","Thibaut Courtois","Jordan Pickford","Nick Pope","Sam Johnstone","Joe Hart"],
    CB:  ["Virgil van Dijk","Ruben Dias","William Saliba","John Stones","Josko Gvardiol","Lisandro Martinez","Marquinhos","Pau Torres","Antonio Rudiger","Ben White"],
    RB:  ["Trent Alexander-Arnold","Kyle Walker","Reece James","Kieran Trippier","Achraf Hakimi","Benjamin Pavard","Diogo Dalot","Aaron Wan-Bissaka","Matty Cash","Tariq Lamptey"],
    LB:  ["Andrew Robertson","Oleksandr Zinchenko","Luke Shaw","Ben Chilwell","Alphonse Davies","Theo Hernandez","David Raum","Alejandro Grimaldo","Ian Maatsen","Sergio Reguilon"],
    CDM: ["Rodri","Casemiro","Fabinho","Declan Rice","Jordan Henderson","Wilfried Ndidi","Yves Bissouma","Douglas Luiz","Granit Xhaka","N'Golo Kante"],
    CM:  ["Kevin De Bruyne","Martin Odegaard","Bruno Fernandes","Bernardo Silva","Phil Foden","Jude Bellingham","Mason Mount","Alexis Mac Allister","Conor Gallagher","James Maddison"],
    CAM: ["Kai Havertz","Isco","David Silva","Juan Mata","Mesut Ozil","James Ward-Prowse","Emile Smith Rowe","Jack Grealish","Leandro Trossard","Eberechi Eze"],
    LW:  ["Sadio Mane","Mohamed Salah","Leroy Sane","Raheem Sterling","Gabriel Martinelli","Son Heung-min","Luis Diaz","Bukayo Saka","Marcus Rashford","Ansu Fati"],
    RW:  ["Mohamed Salah","Leroy Sane","Raheem Sterling","Bukayo Saka","Pedro Neto","Riyad Mahrez","Heung-min Son","Jarrod Bowen","Said Benrahma","Dejan Kulusevski"],
    ST:  ["Erling Haaland","Harry Kane","Robert Lewandowski","Karim Benzema","Gabriel Jesus","Darwin Nunez","Ollie Watkins","Chris Wood","Danny Ings","Ivan Toney"],
  };

  /* ── TIERS — drive realistic ability ranges ── */
  const tiers = [
    { name:"World Class",  weight:2,  ovrBoost:[88,97], ageRange:[21,32], tier:1 },
    { name:"Premier",      weight:8,  ovrBoost:[80,88], ageRange:[19,34], tier:1 },
    { name:"Championship", weight:18, ovrBoost:[70,80], ageRange:[17,35], tier:2 },
    { name:"League One",   weight:28, ovrBoost:[60,70], ageRange:[16,36], tier:3 },
    { name:"Grassroots",   weight:30, ovrBoost:[48,62], ageRange:[15,38], tier:4 },
    { name:"Wonderkid",    weight:8,  ovrBoost:[58,75], ageRange:[15,20], tier:2 },
    { name:"Veteran",      weight:6,  ovrBoost:[62,78], ageRange:[33,40], tier:3 },
  ];
  const totalTierW = tiers.reduce((s,t)=>s+t.weight,0);
  const pickTier = () => {
    let r = seededRand()*totalTierW;
    for(const t of tiers){ r-=t.weight; if(r<=0) return t; }
    return tiers[0];
  };

  const rand = (min,max) => Math.floor(seededRand()*(max-min+1))+min;
  const pick = arr => arr[rand(0,arr.length-1)];
  const clamp = (v,min,max) => Math.max(min,Math.min(max,v));

  const valueByOvr = (ovr) => {
    if(ovr>=92) return `£${(seededRand()*20+10).toFixed(1)}M`;
    if(ovr>=88) return `£${(seededRand()*8+3).toFixed(1)}M`;
    if(ovr>=82) return `£${(seededRand()*2+0.8).toFixed(1)}M`;
    if(ovr>=76) return `£${(seededRand()*700+200).toFixed(0)}K`;
    if(ovr>=70) return `£${(seededRand()*180+50).toFixed(0)}K`;
    if(ovr>=62) return `£${(seededRand()*60+10).toFixed(0)}K`;
    return `£${(seededRand()*15+2).toFixed(0)}K`;
  };

  const wageByOvr = (ovr) => {
    if(ovr>=92) return `£${(seededRand()*80+40).toFixed(0)}K/w`;
    if(ovr>=88) return `£${(seededRand()*30+15).toFixed(0)}K/w`;
    if(ovr>=82) return `£${(seededRand()*8+3).toFixed(1)}K/w`;
    if(ovr>=76) return `£${rand(1000,3000)}/w`;
    if(ovr>=70) return `£${rand(400,1000)}/w`;
    if(ovr>=62) return `£${rand(150,400)}/w`;
    return `£${rand(40,150)}/w`;
  };

  let players = [];
  let id = 1;

  positions.forEach(({pos,group,count,styles,attrs}) => {
    for(let i=0;i<count;i++){
      const tier = pickTier();
      const age = rand(tier.ageRange[0], tier.ageRange[1]);

      // Base attrs from position ranges
      let pace     = rand(attrs.pace[0],     attrs.pace[1]);
      let shooting = rand(attrs.shooting[0], attrs.shooting[1]);
      let passing  = rand(attrs.passing[0],  attrs.passing[1]);
      let dribbling= rand(attrs.dribbling[0],attrs.dribbling[1]);
      let defending= rand(attrs.defending[0],attrs.defending[1]);
      let physical = rand(attrs.physical[0], attrs.physical[1]);

      // Apply tier OVR boost — scale attrs up/down to hit target OVR range
      const rawOvr = Math.round((pace+shooting+passing+dribbling+defending+physical)/6);
      const targetOvr = rand(tier.ovrBoost[0], tier.ovrBoost[1]);
      const scale = targetOvr/rawOvr;
      pace      = clamp(Math.round(pace*scale),      10, 99);
      shooting  = clamp(Math.round(shooting*scale),  10, 99);
      passing   = clamp(Math.round(passing*scale),   10, 99);
      dribbling = clamp(Math.round(dribbling*scale), 10, 99);
      defending = clamp(Math.round(defending*scale), 10, 99);
      physical  = clamp(Math.round(physical*scale),  10, 99);

      const overall = Math.round((pace+shooting+passing+dribbling+defending+physical)/6);

      // Wonderkid bonus — high potential gap
      const isWonderkid = tier.name==="Wonderkid" || (age<=20 && seededRand()<0.15);
      const potential = isWonderkid
        ? clamp(overall + rand(10,25), overall, 99)
        : clamp(overall + rand(0,8), overall, 99);

      // Pick club based on tier
      const clubPool = tier.tier===1?clubs.tier1:tier.tier===2?clubs.tier2:tier.tier===3?clubs.tier3:clubs.tier4;
      const club = pick(clubPool);

      // Veteran attribute adjustments
      const isVet = age>=33;
      if(isVet){ pace = clamp(pace-rand(3,10),10,99); }

      const style = pick(styles);
      const personality = pick(personalities);
      const proRef = proRefs[pos] ? pick(proRefs[pos]) : "";

      // Injury/availability
      const availRoll = seededRand();
      const availability = availRoll<0.05?"Injured":availRoll<0.12?"Doubt":availRoll<0.18?"Suspended":"Available";

      // Form (last 5 matches)
      const form = Array.from({length:5},()=>pick(["W","W","W","D","D","L"]));
      const morale = pick(["Excellent","Very Good","Good","OK","Poor"]);

      players.push({
        id, pos, group,
        name: `${pick(firstNames)} ${pick(lastNames)}`,
        age,
        club,
        nat: pickNat(),
        foot: seededRand()>0.22?"R":"L",
        height: `${rand(165,200)}cm`,
        overall, potential,
        pace, shooting, passing, dribbling, defending, physical,
        value: valueByOvr(overall),
        wage: wageByOvr(overall),
        style,
        personality,
        proRef,
        tier: tier.name,
        isWonderkid,
        isVet,
        availability,
        form,
        morale,
        contractYears: rand(0,5),
        appearances: rand(0,42),
        goals: pos==="ST"?rand(0,32):pos==="CAM"?rand(0,18):["LW","RW","CM"].includes(pos)?rand(0,12):rand(0,6),
        assists: ["CAM","LW","RW","CM","CAM"].includes(pos)?rand(0,22):rand(0,10),
        yellowCards: rand(0,12),
        redCards: rand(0,2),
        distanceCovered: `${(rand(85,115)/10).toFixed(1)}km`,
        pressWins: rand(0,48),
        watched: false,
        videos: rand(0,8),
        reports: rand(0,5),
      });
      id++;
    }
  });

  // Sort by overall descending
  return players.sort((a,b)=>b.overall-a.overall);
};

const ALL_PLAYERS = generatePlayers();


const PRO_STYLES_DB = [
  {club:"Manchester City",color:"#b3e5fc",positions:["ST","CAM","CM"],matchReason:"Positional awareness and combination play in tight spaces"},
  {club:"Liverpool FC",color:"#ffccbc",positions:["ST","LW","RW","CM"],matchReason:"High energy pressing and rapid vertical transitions"},
  {club:"Arsenal FC",color:"#dcedc8",positions:["CM","CAM","RW","LW","RB","LB"],matchReason:"Structured build-up with overlapping runs and half-space combinations"},
  {club:"Atlético Madrid",color:"#c8e6c9",positions:["ST","CM","CB","GK"],matchReason:"Defensive discipline and rapid counter-attacking transitions"},
  {club:"Real Madrid",color:"#fff9c4",positions:["CAM","CM","LW","ST"],matchReason:"Creative freedom and late runs into the final third"},
  {club:"Bayer Leverkusen",color:"#e1bee7",positions:["LW","CM","LB","CB"],matchReason:"Possession-based play with aggressive pressing triggers"},
];

const COACHING_TIPS = {
  GK: [
    {title:"Distribution Drills",desc:"Work on short passing under pressure to build from the back confidently. Set up 3v2 scenarios where the keeper must find a free player."},
    {title:"Sweeping Range",desc:"Practise claiming crosses at the highest point and sweeping behind the defensive line. Use cone gates to define the sweeping zone."},
    {title:"Shot-stopping Footwork",desc:"Lateral movement reaction drills — quick feet, low centre of gravity. React to a server's cue rather than the ball direction."},
  ],
  CB: [
    {title:"Ball-playing Under Pressure",desc:"Set up 3v3 pressing scenarios starting from the back. The CB must play through the press with a minimum of 3 passes before progressing."},
    {title:"Aerial Dominance",desc:"Cross delivery from wide areas with a target man — work on the jump, timing and command of the box under physical challenge."},
    {title:"Defensive Line Communication",desc:"Coordinate offside trap timing with your partner CB. Use verbal cues — practice stepping up as a unit from set pieces."},
  ],
  RB: [
    {title:"Overlap Timing",desc:"Work on the overlap run with the winger. The full-back must read when the winger has drawn their marker before making the run."},
    {title:"Defensive Recovery",desc:"1v1 recovery runs when caught high — practice the drop step and body positioning to force the attacker wide."},
    {title:"Crossing Variety",desc:"Driven cross, floated cross, cut-back. Rehearse all three from the byline with a server providing the ball at pace."},
  ],
  LB: [
    {title:"Inverted Carry",desc:"If left-footed, practice cutting inside onto the right to create shooting angles from deep. Like Grimaldo — enter the half-space from the left."},
    {title:"Overlap Timing",desc:"Work on the overlap run timing in combination with the left winger drawing the full-back's marker."},
    {title:"Defensive Positioning",desc:"Practice the cover shadow — position to cut passing lanes into the striker while staying goalside."},
  ],
  CDM: [
    {title:"Press-breaking Turns",desc:"Receive under pressure and turn into space. Practice the Cruyff turn, la croqueta and disguised passes with a presser on your back."},
    {title:"Screening the Back Four",desc:"Work on positional discipline — always be in line to intercept or cut passing lanes between the lines."},
    {title:"Transition Recovery",desc:"Sprint back to defensive shape after losing possession — gate sprints to replicate the urgency of the first 5 seconds after turnover."},
  ],
  CM: [
    {title:"Box-to-Box Stamina",desc:"Interval training matching match intensity — 70m sprints with a 30 second recovery, 10 reps. Replicate the demand of covering both penalty areas."},
    {title:"Late Runs",desc:"Time runs from deep into the box — trigger off the striker's movement, not the ball. Practice arriving at the back post at the right moment."},
    {title:"Combination Play",desc:"Wall pass and third-man combinations with two other midfielders. Work in tight grid with a pressing pair."},
  ],
  CAM: [
    {title:"Half-space Receiving",desc:"Practice receiving in the channel between CB and FB. Show early, check away, then spin — create shooting angles from the half-space."},
    {title:"Through-ball Timing",desc:"Play through-balls in behind a high defensive line — timing is everything. The pass must be played as the run starts, not after."},
    {title:"Pressing from the Front",desc:"The CAM is the first defender. Practice the press trigger — when to press and when to hold the shape and cut passing lanes."},
  ],
  LW: [
    {title:"1v1 Isolation",desc:"Set up 1v1 duel scenarios from a standing start. Work on the shoulder drop, step over and driving acceleration past the defender."},
    {title:"Cutting Inside",desc:"Practice the inside cut from the left — create the shooting opportunity on the right foot or the cut-back opportunity."},
    {title:"Pressing and Recovering",desc:"Win ball high and transition instantly. Use a small-sided game where the winger must recover defensively when possession is lost."},
  ],
  RW: [
    {title:"Inverted Movement",desc:"Practice receiving wide and driving inside. Create overloads in the half-space by arriving late as the striker drags defenders."},
    {title:"1v1 Pace Duel",desc:"50m acceleration duel against a defender — body position, angle of run and first touch are key to winning the race."},
    {title:"Cross Decision Making",desc:"Practice the decision — when to cut inside vs when to deliver. Work on reading the defensive shape before making the choice."},
  ],
  ST: [
    {title:"Finishing Variety",desc:"Work on all finishes — driven low, placed far post, lofted, header. Practise from different angles with service from both sides."},
    {title:"Movement Off the Ball",desc:"Shadow play without the ball — practice the checking run, the spin in behind and the diagonal run across the centre-back."},
    {title:"Hold-up and Link Play",desc:"Back to goal with a presser — control, hold, lay off and spin. Build combinations with a supporting midfielder."},
  ],
};

const attrColor = (v) => v>=80?"#16a34a":v>=65?"#d4941a":"#8b2a2a";
const attrClass = (v) => v>=80?"av-hi":v>=65?"av-md":"av-lo";
const posGroup = (pos) => {
  if(pos==="GK") return "gk";
  if(["CB","RB","LB"].includes(pos)) return "def";
  if(["CDM","CM","CAM"].includes(pos)) return "mid";
  return "att";
};
const ini = (n) => n.split(" ").map(w=>w[0]).join("");

/* ── MINI RADAR BARS ── */
function RadarBars({player}){
  const bars = [
    {k:"PAC",v:player.pace,c:"#2e7d7a"},
    {k:"SHO",v:player.shooting,c:"#8b2a2a"},
    {k:"PAS",v:player.passing,c:"#d4941a"},
    {k:"DRI",v:player.dribbling,c:"#16a34a"},
    {k:"DEF",v:player.defending,c:"#4f46e5"},
    {k:"PHY",v:player.physical,c:"#c2410c"},
  ];
  return(
    <div className="pc-radar">
      {bars.map(b=>(
        <div key={b.k} className="pc-radar-bar" title={`${b.k}: ${b.v}`}>
          <div className="pc-radar-fill" style={{height:`${b.v}%`,background:b.c,opacity:0.7}}/>
        </div>
      ))}
    </div>
  );
}

/* ── FULL ATTRIBUTE BAR ── */
function AttrBar({label,value}){
  return(
    <div className="pp-attr-row">
      <span className="pp-attr-label">{label}</span>
      <div className="pp-attr-bar-bg">
        <div className="pp-attr-bar-fill" style={{width:`${value}%`,background:attrColor(value),opacity:0.8}}/>
      </div>
      <span className="pp-attr-val" style={{color:attrColor(value)}}>{value}</span>
    </div>
  );
}

/* ── PLAYER PROFILE MODAL ── */
function PlayerProfile({player,onClose,onWatch,isScout}){
  const [stars,setStars]=useState(0);
  const [interest,setInterest]=useState("");
  const [notes,setNotes]=useState("");
  const [saved,setSaved]=useState(false);


  const tips = COACHING_TIPS[player.pos]||COACHING_TIPS["CM"];
  const matchedStyles = PRO_STYLES_DB.filter(s=>s.positions.includes(player.pos));

  const strengths = [];
  const weaknesses = [];
  if(player.pace>=80)      strengths.push("Exceptional pace — dangerous in behind");
  if(player.shooting>=80)  strengths.push("Clinical finishing — composure in the box");
  if(player.passing>=82)   strengths.push("Elite passing range — can unlock defences");
  if(player.dribbling>=80) strengths.push("Outstanding dribbling — creates in 1v1 situations");
  if(player.defending>=82) strengths.push("Dominant defensively — reads the game well");
  if(player.physical>=82)  strengths.push("Physically imposing — wins duels consistently");
  if(player.pace<60)       weaknesses.push("Limited pace — may struggle against quick attackers");
  if(player.shooting<55)   weaknesses.push("Finishing needs development — low shot accuracy");
  if(player.passing<62)    weaknesses.push("Distribution inconsistent — too many loose passes");
  if(player.defending<55)  weaknesses.push("Defensive positioning — positional discipline lacking");

  return(
    <div className="pp-modal">
      <div className="pp-inner">
        <button className="pp-back" onClick={onClose}>← Back to Database</button>

        {/* Header */}
        <div className="pp-header">
          <div className="pp-avatar">{ini(player.name)}</div>
          <div className="pp-info">
            <div className="pp-name">{player.name}</div>
            <div className="pp-detail">{player.nat} · Age {player.age} · {player.club} · {player.foot} Foot · {player.height}</div>
            <div className="pp-tags">
              <span className={`pp-tag highlight`}>{player.pos}</span>
              <span className="pp-tag">{player.style}</span>
              <span className="pp-tag">Est. Value: {player.value}</span>
              <span className="pp-tag">{player.appearances} apps · {player.goals}G · {player.assists}A</span>
              {player.isWonderkid&&<span className="pp-tag highlight">⭐ Wonderkid</span>}
              {player.isVet&&<span className="pp-tag" style={{background:"var(--muted)",color:"white"}}>Veteran</span>}
            </div>
          </div>
          <div className="pp-ovr-block">
            <div className="pp-ovr">{player.overall}</div>
            <div className="pp-ovr-lbl">Overall</div>
            <div className="pp-pot-block" style={{marginTop:"0.5rem"}}>
              <div className="pp-pot-lbl">Potential</div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.4rem",letterSpacing:"2px",color:"#4ade80"}}>{player.potential}</div>
            </div>
          </div>
        </div>

        {/* Attributes + Strengths */}
        <div className="pp-grid">
          <div className="pp-panel">
            <div className="pp-panel-title">Attributes <span className="pp-panel-chip">FM Style</span></div>
            <div className="pp-attrs-full">
              <AttrBar label="Pace" value={player.pace}/>
              <AttrBar label="Shooting" value={player.shooting}/>
              <AttrBar label="Passing" value={player.passing}/>
              <AttrBar label="Dribbling" value={player.dribbling}/>
              <AttrBar label="Defending" value={player.defending}/>
              <AttrBar label="Physical" value={player.physical}/>
            </div>
          </div>

          <div className="pp-panel">
            <div className="pp-panel-title">Analysis <span className="pp-panel-chip">AI Generated</span></div>
            <div className="sw-list">
              {strengths.length>0&&<><div style={{fontSize:"0.6rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"#16a34a",marginBottom:"0.3rem"}}>Strengths</div>
              {strengths.map((s,i)=><div key={i} className="sw-item"><div className="sw-dot good"/><span style={{fontSize:"0.78rem",fontWeight:400,color:"var(--ink2)"}}>{s}</span></div>)}</>}
              {weaknesses.length>0&&<><div style={{fontSize:"0.6rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"var(--darkred)",marginBottom:"0.3rem",marginTop:"0.6rem"}}>Areas to Develop</div>
              {weaknesses.map((w,i)=><div key={i} className="sw-item"><div className="sw-dot bad"/><span style={{fontSize:"0.78rem",fontWeight:400,color:"var(--ink2)"}}>{w}</span></div>)}</>}
              {strengths.length===0&&weaknesses.length===0&&<div style={{fontSize:"0.82rem",color:"var(--muted)",fontStyle:"italic",fontWeight:300}}>Well-rounded player — no standout weaknesses. Good rotation option.</div>}
            </div>
          </div>
        </div>

        {/* Coaching Recommendations */}
        <div className="pp-panel" style={{marginBottom:"1rem"}}>
          <div className="pp-panel-title">Coaching Recommendations <span className="pp-panel-chip">For {player.pos}</span></div>
          <div className="coach-recs">
            {tips.map((t,i)=>(
              <div key={i} className="coach-rec">
                <div className="coach-rec-title">{t.title}</div>
                <div className="coach-rec-desc">{t.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Pro Style Matches */}
        <div className="pp-panel" style={{marginBottom:"1rem"}}>
          <div className="pp-panel-title">Pro Style Matches <span className="pp-panel-chip">{matchedStyles.length} Found</span></div>
          {matchedStyles.map((s,i)=>{
            const pct = Math.round(70+seededRand()*25);
            return(
              <div key={i} className="style-match">
                <div className="style-match-color" style={{background:s.color}}/>
                <div className="style-match-info">
                  <div className="style-match-club">{s.club}</div>
                  <div className="style-match-reason">{s.matchReason}</div>
                </div>
                <div className="style-match-pct">{pct}%</div>
              </div>
            );
          })}
        </div>

        {/* Scout Report Form */}
        {isScout&&(
          <div className="pp-panel" style={{marginBottom:"1rem"}}>
            <div className="pp-panel-title">File Scout Report</div>
            <div className="sr-form">
              <div>
                <label className="sr-label">Overall Rating</label>
                <div className="sr-stars">{[1,2,3,4,5].map(s=><span key={s} className={`sr-star ${stars>=s?"on":""}`} onClick={()=>setStars(s)}>★</span>)}</div>
              </div>
              <div>
                <label className="sr-label">Interest Level</label>
                <div className="sr-interest">
                  {[{k:"sign",l:"🟢 Sign Now"},{k:"monitor",l:"🟡 Monitor"},{k:"keep",l:"🔵 Keep on File"},{k:"pass",l:"🔴 Pass"}].map(b=>(
                    <button key={b.k} className={`sr-int-btn ${interest===b.k?"on "+b.k:""}`} onClick={()=>setInterest(b.k)}>{b.l}</button>
                  ))}
                </div>
              </div>
              <div>
                <label className="sr-label">Match Watched</label>
                <input className="sr-input" placeholder="e.g. vs North United, 12 Apr 2026"/>
              </div>
              <div>
                <label className="sr-label">Scout Notes</label>
                <textarea className="sr-ta" placeholder="Detail the player's strengths, weaknesses, movement, attitude and potential..." value={notes} onChange={e=>setNotes(e.target.value)}/>
              </div>
              <div>
                <label className="sr-label">Recommended Fee</label>
                <input className="sr-input" placeholder="e.g. £250K"/>
              </div>
              <button className="sr-submit" onClick={()=>{setSaved(true);setTimeout(()=>setSaved(false),2500);}}>
                {saved?"✦ Report Saved to Database!":"Submit Scout Report"}
              </button>
            </div>
          </div>
        )}

        {/* Watch / Unwatch */}
        <button
          style={{width:"100%",padding:"0.85rem",background:player.watched?"var(--darkred)":"var(--teal)",color:"var(--white)",border:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:800,fontSize:"0.8rem",letterSpacing:"2px",textTransform:"uppercase",cursor:"pointer"}}
          onClick={()=>{onWatch(player.id);onClose();}}>
          {player.watched?"★ Remove from Watchlist":"☆ Add to Watchlist"}
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════
   MAIN PLAYER DATABASE COMPONENT
══════════════════════════════════ */
export default function PlayerDatabase({isScout=false,watchlistOnly=false}){
  const [players, setPlayers] = useState(() => {
    const watched = JSON.parse(localStorage.getItem('footyanalyst_db_watched') || '[]');
    return ALL_PLAYERS.map(p => ({...p, watched: watched.includes(p.id)}));
  });
  const [search,setSearch]   = useState("");
  const [posFilter,setPosFilter] = useState("All");
  const [groupFilter,setGroupFilter] = useState("All");
  const [sortBy,setSortBy]   = useState("overall");
  const [sortDir,setSortDir] = useState("desc");
  const [viewMode,setViewMode] = useState("grid");
  const [selPlayer,setSelPlayer] = useState(null);
  const [compareList,setCompareList] = useState([]);
  const [showCompare,setShowCompare] = useState(false);
  const [minOvr,setMinOvr]   = useState(0);
  const [maxAge,setMaxAge]    = useState(99);
  const [potentialOnly,setPotentialOnly] = useState(false);
  const [tierFilter,setTierFilter] = useState("All");
  const [availFilter,setAvailFilter] = useState("All");

  const toggleWatch = (id) => {
    setPlayers(ps => {
      const updated = ps.map(p => p.id === id ? {...p, watched: !p.watched} : p);
      const watchedIds = updated.filter(p => p.watched).map(p => p.id);
      localStorage.setItem('footyanalyst_db_watched', JSON.stringify(watchedIds));
      return updated;
    });
  };

  const toggleCompare = (player) => {
    setCompareList(prev=>{
      if(prev.find(p=>p.id===player.id)) return prev.filter(p=>p.id!==player.id);
      if(prev.length>=3) return prev;
      return [...prev,player];
    });
  };

  const filtered = useMemo(()=>{
    let list = watchlistOnly ? players.filter(p=>p.watched) : players;

    if(search) list=list.filter(p=>
      p.name.toLowerCase().includes(search.toLowerCase())||
      p.club.toLowerCase().includes(search.toLowerCase())||
      p.style.toLowerCase().includes(search.toLowerCase())||
      p.pos.toLowerCase().includes(search.toLowerCase())||
      (p.nat||"").includes(search)||
      (p.personality||"").toLowerCase().includes(search.toLowerCase())
    );
    if(posFilter!=="All") list=list.filter(p=>p.pos===posFilter);
    if(groupFilter!=="All") list=list.filter(p=>p.group===groupFilter);
    if(minOvr>0) list=list.filter(p=>p.overall>=minOvr);
    if(maxAge<99) list=list.filter(p=>p.age<=maxAge);
    if(potentialOnly) list=list.filter(p=>p.isWonderkid||(p.potential-p.overall>=8&&p.age<=22));
    if(tierFilter==="Wonderkid") list=list.filter(p=>p.isWonderkid);
    else if(tierFilter==="Veteran") list=list.filter(p=>p.isVet);
    else if(tierFilter!=="All") list=list.filter(p=>p.tier===tierFilter);
    if(availFilter!=="All") list=list.filter(p=>p.availability===availFilter);

    list=[...list].sort((a,b)=>{
      const dir=sortDir==="desc"?-1:1;
      if(sortBy==="name") return dir*a.name.localeCompare(b.name);
      if(sortBy==="age") return dir*(a.age-b.age);
      return dir*(a[sortBy]-b[sortBy]);
    });

    return list;
  },[players,search,posFilter,groupFilter,sortBy,sortDir,minOvr,maxAge,potentialOnly,tierFilter,availFilter,watchlistOnly]);

  const watchedCount = players.filter(p=>p.watched).length;
  const highPotCount = players.filter(p=>p.isWonderkid||(p.potential-p.overall>=8&&p.age<=22)).length;
  const wonderkidCount = players.filter(p=>p.isWonderkid).length;

  return(
    <>
      <style>{DB_CSS}</style>
      {selPlayer&&(
        <PlayerProfile
          player={selPlayer}
          onClose={()=>setSelPlayer(null)}
          onWatch={toggleWatch}
          isScout={isScout}
        />
      )}

      {showCompare&&compareList.length>=2&&(
        <div className="pp-modal">
          <div className="pp-inner">
            <button className="pp-back" onClick={()=>setShowCompare(false)}>← Back</button>
            <div style={{background:"var(--teal2)",padding:"1.2rem 1.5rem",marginBottom:"1rem",borderBottom:"3px solid var(--mustard)"}}>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"1.8rem",letterSpacing:"3px",color:"var(--white)"}}>Player Comparison</div>
              <div style={{fontSize:"0.72rem",color:"rgba(255,255,255,0.55)",fontStyle:"italic",marginTop:"0.2rem"}}>Side-by-side attribute analysis</div>
            </div>
            <div className="cmp-grid" style={{gridTemplateColumns:`120px repeat(${compareList.length},1fr)`}}>
              <div/>
              {compareList.map(p=>(
                <div key={p.id} style={{background:"var(--white)",border:"1.5px solid var(--rule)",padding:"0.9rem",textAlign:"center"}}>
                  <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.9rem",fontWeight:800}}>{p.name}</div>
                  <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.65rem",color:"var(--muted)",fontStyle:"italic"}}>{p.club}</div>
                  <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"2rem",letterSpacing:"2px",color:"var(--darkred)",marginTop:"0.3rem"}}>{p.overall}</div>
                  <div style={{fontSize:"0.55rem",color:"var(--muted)",letterSpacing:"2px",textTransform:"uppercase",fontWeight:600}}>Overall</div>
                </div>
              ))}
            </div>
            {[["Pace","pace"],["Shooting","shooting"],["Passing","passing"],["Dribbling","dribbling"],["Defending","defending"],["Physical","physical"]].map(([label,key])=>{
              const max=Math.max(...compareList.map(p=>p[key]));
              return(
                <div key={key} className="pp-panel" style={{marginBottom:"0.5rem"}}>
                  <div style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.62rem",fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",color:"var(--teal)",marginBottom:"0.6rem"}}>{label}</div>
                  {compareList.map(p=>(
                    <div key={p.id} className="cmp-attr-row">
                      <span style={{fontFamily:"'DM Sans',sans-serif",fontSize:"0.75rem",fontWeight:700,width:"120px",flexShrink:0,color:"var(--ink)"}}>{p.name.split(" ")[0]}</span>
                      <div className="cmp-bar-wrap">
                        <div className="cmp-bar-bg">
                          <div className="cmp-bar-fill" style={{left:0,width:`${p[key]}%`,background:attrColor(p[key]),opacity:0.75}}/>
                        </div>
                        <span className="cmp-val" style={{color:attrColor(p[key])}}>{p[key]}</span>
                        {p[key]===max&&<span style={{fontSize:"0.6rem",color:"#16a34a",fontWeight:800}}>▲</span>}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="db-wrap">
        {/* Header */}
        <div className="db-header">
          <div className="db-header-left">
            <h2>{watchlistOnly?"My Watchlist":"Player Database"}</h2>
            <p>{watchlistOnly?"Players you're tracking":"Full scouting database — all positions, all levels"}</p>
          </div>
          <div className="db-stats-row">
            <div className="db-stat"><div className="db-stat-n">{players.length}</div><div className="db-stat-l">Total Players</div></div>
            <div className="db-stat"><div className="db-stat-n">{watchedCount}</div><div className="db-stat-l">Watched</div></div>
            <div className="db-stat"><div className="db-stat-n">{wonderkidCount}</div><div className="db-stat-l">Wonderkids</div></div>
            <div className="db-stat"><div className="db-stat-n">{filtered.length}</div><div className="db-stat-l">Showing</div></div>
          </div>
        </div>

        {/* Controls */}
        <div className="db-controls">
          <input
            className="db-search"
            placeholder="Search by name, club, position or style..."
            value={search}
            onChange={e=>setSearch(e.target.value)}
          />
          <select className="db-select" value={sortBy} onChange={e=>setSortBy(e.target.value)}>
            <option value="overall">Sort: Overall</option>
            <option value="potential">Sort: Potential</option>
            <option value="pace">Sort: Pace</option>
            <option value="shooting">Sort: Shooting</option>
            <option value="passing">Sort: Passing</option>
            <option value="dribbling">Sort: Dribbling</option>
            <option value="defending">Sort: Defending</option>
            <option value="physical">Sort: Physical</option>
            <option value="age">Sort: Age</option>
          </select>
          <select className="db-select" value={sortDir} onChange={e=>setSortDir(e.target.value)}>
            <option value="desc">↓ High to Low</option>
            <option value="asc">↑ Low to High</option>
          </select>
          <select className="db-select" value={minOvr} onChange={e=>setMinOvr(Number(e.target.value))}>
            <option value={0}>Min Rating: Any</option>
            <option value={90}>Min Rating: 90+</option>
            <option value={85}>Min Rating: 85+</option>
            <option value={80}>Min Rating: 80+</option>
            <option value={75}>Min Rating: 75+</option>
            <option value={70}>Min Rating: 70+</option>
            <option value={60}>Min Rating: 60+</option>
          </select>
          <select className="db-select" value={maxAge} onChange={e=>setMaxAge(Number(e.target.value))}>
            <option value={99}>Max Age: Any</option>
            <option value={23}>Max Age: U23</option>
            <option value={21}>Max Age: U21</option>
            <option value={19}>Max Age: U19</option>
            <option value={18}>Max Age: U18</option>
          </select>
          <select className="db-select" value={tierFilter} onChange={e=>setTierFilter(e.target.value)}>
            <option value="All">All Tiers</option>
            <option value="World Class">World Class</option>
            <option value="Premier">Premier</option>
            <option value="Championship">Championship</option>
            <option value="League One">League One</option>
            <option value="Grassroots">Grassroots</option>
            <option value="Wonderkid">Wonderkids Only</option>
            <option value="Veteran">Veterans Only</option>
          </select>
          <select className="db-select" value={availFilter} onChange={e=>setAvailFilter(e.target.value)}>
            <option value="All">Availability: All</option>
            <option value="Available">Available</option>
            <option value="Doubt">Doubt</option>
            <option value="Injured">Injured</option>
          </select>
          <button
            className="db-select"
            style={{cursor:"pointer",background:potentialOnly?"var(--mustard)":"transparent",fontWeight:800,color:potentialOnly?"var(--ink)":"var(--muted)"}}
            onClick={()=>setPotentialOnly(p=>!p)}
          >⭐ High Potential</button>
          <div className="db-view-btns">
            <button className={`db-view-btn ${viewMode==="grid"?"on":""}`} onClick={()=>setViewMode("grid")}>⊞ Grid</button>
            <button className={`db-view-btn ${viewMode==="list"?"on":""}`} onClick={()=>setViewMode("list")}>≡ List</button>
          </div>
        </div>

        {/* Position filters */}
        <div className="db-pos-filters">
          <span className="db-pos-label">Position</span>
          {["All","GK","CB","RB","LB","CDM","CM","CAM","LW","RW","ST"].map(p=>(
            <button key={p} className={`pos-btn ${posGroup(p)} ${posFilter===p?"on":""}`} onClick={()=>{setPosFilter(p);setGroupFilter("All");}}>
              {p}
            </button>
          ))}
          <span className="db-pos-label" style={{marginLeft:"0.8rem"}}>Group</span>
          {[{k:"All",l:"All"},{k:"gk",l:"GK"},{k:"def",l:"DEF"},{k:"mid",l:"MID"},{k:"att",l:"ATT"}].map(g=>(
            <button key={g.k} className={`pos-btn ${g.k} ${groupFilter===g.k?"on":""}`} onClick={()=>{setGroupFilter(g.k);setPosFilter("All");}}>
              {g.l}
            </button>
          ))}
        </div>

        {/* Sort bar */}
        <div className="db-sort-bar">
          <span className="sort-label">Quick Sort</span>
          {[["Overall","overall"],["Pace","pace"],["Shooting","shooting"],["Passing","passing"],["Dribbling","dribbling"],["Defending","defending"],["Physical","physical"],["Potential","potential"],["Age","age"]].map(([l,k])=>(
            <button key={k} className={`sort-btn ${sortBy===k?"on":""}`} onClick={()=>{setSortBy(k);setSortDir(sortBy===k&&sortDir==="desc"?"asc":"desc");}}>
              {l} {sortBy===k?(sortDir==="desc"?"↓":"↑"):""}
            </button>
          ))}
        </div>

        {/* Results bar */}
        <div className="db-results-bar">
          <div className="db-results-count">Showing <span>{filtered.length}</span> of {players.length} players</div>
          {compareList.length>0&&<div style={{fontSize:"0.7rem",fontWeight:700,color:"var(--teal)"}}>⊕ {compareList.length} selected for comparison</div>}
        </div>

        {/* GRID VIEW */}
        {viewMode==="grid"&&(
          <div className="db-grid">
            {filtered.length===0?(
              <div className="db-empty" style={{gridColumn:"1/-1"}}>
                <div className="db-empty-icon">🔍</div>
                <div className="db-empty-title">No Players Found</div>
                <div className="db-empty-sub">Try adjusting your search or filters</div>
              </div>
            ):filtered.map((p,i)=>(
              <div key={p.id} className={`pc ${p.watched?"watched":""} ${p.isWonderkid?"high-potential":""}`} style={{animationDelay:`${i*0.03}s`}}>
                <div className="pc-head">
                  <div className="pc-left">
                    <div className="pc-name">
                      {p.name}
                      {p.isWonderkid&&<span style={{color:"var(--mustard)",marginLeft:"0.3rem",fontSize:"0.75rem"}}>⭐</span>}
                      {p.isVet&&<span style={{color:"var(--muted)",marginLeft:"0.3rem",fontSize:"0.65rem",fontStyle:"italic"}}>Vet</span>}
                    </div>
                    <div className="pc-club">{p.nat} · {p.club}</div>
                    <div className="pc-tags">
                      <span className={`pc-pos ${p.group}`}>{p.pos}</span>
                      <span className="pc-age">Age {p.age}</span>
                      <span style={{fontSize:"0.56rem",fontWeight:800,padding:"0.08rem 0.35rem",letterSpacing:"1px",textTransform:"uppercase",
                        color:p.availability==="Available"?"#16a34a":p.availability==="Doubt"?"var(--mustard)":"var(--darkred)",
                        border:`1px solid ${p.availability==="Available"?"#16a34a":p.availability==="Doubt"?"var(--mustard)":"var(--darkred)"}`}}>
                        {p.availability}
                      </span>
                    </div>
                  </div>
                  <div className="pc-right">
                    <div className="pc-ovr">{p.overall}</div>
                    <div className="pc-ovr-lbl">OVR</div>
                    <div className="pc-pot" style={{color:p.potential-p.overall>=8?"var(--mustard)":"var(--muted)"}}>↑{p.potential} POT</div>
                  </div>
                </div>
                <div className="pc-attrs">
                  {[["PAC",p.pace],["SHO",p.shooting],["PAS",p.passing],["DRI",p.dribbling],["DEF",p.defending],["PHY",p.physical]].map(([k,v])=>(
                    <div key={k} className="pc-attr">
                      <span className="pc-attr-l">{k}</span>
                      <span className={`pc-attr-v ${attrClass(v)}`}>{v}</span>
                    </div>
                  ))}
                </div>
                <div className="pc-body">
                  <div className="pc-info-row">
                    <span className="pc-info-l">Value</span>
                    <span className="pc-info-v">{p.value}</span>
                  </div>
                  <div className="pc-info-row">
                    <span className="pc-info-l">Wage</span>
                    <span className="pc-info-v">{p.wage}</span>
                  </div>
                  <div className="pc-info-row">
                    <span className="pc-info-l">Foot</span>
                    <span className="pc-info-v">{p.foot} · {p.height}</span>
                  </div>
                  <div className="pc-info-row">
                    <span className="pc-info-l">Season</span>
                    <span className="pc-info-v">{p.goals}G / {p.assists}A / {p.appearances} apps</span>
                  </div>
                  <div className="pc-info-row">
                    <span className="pc-info-l">Personality</span>
                    <span className="pc-info-v" style={{color:"var(--teal)",fontStyle:"italic"}}>{p.personality}</span>
                  </div>
                  <div className="pc-info-row">
                    <span className="pc-info-l">Morale</span>
                    <span className="pc-info-v" style={{color:p.morale==="Excellent"||p.morale==="Very Good"?"#16a34a":p.morale==="Poor"?"var(--darkred)":"var(--mustard)"}}>{p.morale}</span>
                  </div>
                  <div className="pc-style">{p.style}{p.tier==="World Class"||p.tier==="Premier"?` · ${p.tier}`:""}</div>
                  <RadarBars player={p}/>
                </div>
                <div className="pc-actions">
                  <button className="pc-btn" onClick={()=>setSelPlayer(p)}>Full Profile</button>
                  {isScout&&<button className={`pc-btn ${p.watched?"watch-on":""}`} onClick={()=>toggleWatch(p.id)}>{p.watched?"★ Watching":"☆ Watch"}</button>}
                  <button className={`pc-btn ${compareList.find(c=>c.id===p.id)?"watch-on":""}`} onClick={()=>toggleCompare(p)}>
                    {compareList.find(c=>c.id===p.id)?"✓ Cmp":"+ Cmp"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* LIST VIEW */}
        {viewMode==="list"&&(
          <div className="db-list">
            <div className="db-list-header">
              <span>#</span><span>Player</span><span>Pos</span>
              <span style={{textAlign:"center"}}>OVR</span><span style={{textAlign:"center"}}>PAC</span>
              <span style={{textAlign:"center"}}>SHO</span><span style={{textAlign:"center"}}>PAS</span>
              <span style={{textAlign:"center"}}>DRI</span><span style={{textAlign:"center"}}>DEF</span>
              <span>Value</span><span>Actions</span>
            </div>
            {filtered.length===0?(
              <div className="db-empty">
                <div className="db-empty-icon">🔍</div>
                <div className="db-empty-title">No Players Found</div>
                <div className="db-empty-sub">Try adjusting your filters</div>
              </div>
            ):filtered.map((p,i)=>(
              <div key={p.id} className="db-list-row" onClick={()=>setSelPlayer(p)}>
                <span className="db-list-n">{i+1}</span>
                <div>
                  <div className="db-list-name">{p.name} {p.isWonderkid&&"⭐"} {p.isVet&&<span style={{fontSize:"0.6rem",color:"var(--muted)"}}>Vet</span>}</div>
                  <div className="db-list-club">{p.nat} {p.club} · Age {p.age}</div>
                </div>
                <div className="db-list-pos"><span className={`pc-pos ${p.group}`}>{p.pos}</span></div>
                <span className="db-list-ovr">{p.overall}</span>
                <span className={`db-list-attr ${attrClass(p.pace)}`}>{p.pace}</span>
                <span className={`db-list-attr ${attrClass(p.shooting)}`}>{p.shooting}</span>
                <span className={`db-list-attr ${attrClass(p.passing)}`}>{p.passing}</span>
                <span className={`db-list-attr ${attrClass(p.dribbling)}`}>{p.dribbling}</span>
                <span className={`db-list-attr ${attrClass(p.defending)}`}>{p.defending}</span>
                <span className="db-list-val">{p.value}</span>
                <div className="db-list-actions" onClick={e=>e.stopPropagation()}>
                  {isScout&&<button className="db-list-btn" onClick={()=>toggleWatch(p.id)}>{p.watched?"★":"☆"}</button>}
                  <button className="db-list-btn" onClick={()=>toggleCompare(p)}>+Cmp</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Compare bar */}
      {compareList.length>=1&&(
        <div className="compare-bar">
          <div className="compare-bar-title">Compare</div>
          <div className="compare-players">
            {compareList.map(p=>(
              <div key={p.id} className="compare-player-chip">
                <span>{p.name} ({p.overall})</span>
                <span className="compare-remove" onClick={()=>toggleCompare(p)}>×</span>
              </div>
            ))}
          </div>
          {compareList.length>=2&&<button className="btn-compare" onClick={()=>setShowCompare(true)}>Compare →</button>}
          <button className="btn-compare-clear" onClick={()=>setCompareList([])}>Clear</button>
        </div>
      )}
    </>
  );
}
